
const sidebarStatusKey = 'sidebar_status'
export const getSidebarStatus = () => window.sessionStorage.getItem(sidebarStatusKey)
export const setSidebarStatus = (sidebarStatus: string) => window.sessionStorage.setItem(sidebarStatusKey, sidebarStatus)
